module.exports = __webpack_public_path__ + "static/img/7.63e8f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/7.jpg
// module id = Alr3
// module chunks = 1